export const ru = {
    'loading-text': 'Загрузка...'
};
